import { v4 } from 'uuid';
import { isLocalEnvironment } from '~/constants/environment';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function setLocalBrowserCookieId() {
  if (isLocalEnvironment) {
    const browserCookieId = v4();
    BrowserCookies.set('BrowserCookieId', browserCookieId, {
      httpOnly: false
    });
  }
}
